export default __webpack_public_path__ + "static/media/AdditionalFeatures.31f83133.png";